import CityPageTemplate from "../hawaii-city/CityPageTemplate";
import { kapoleiConfig } from "./data";

export default function Page() {
  return <CityPageTemplate config={kapoleiConfig} />;
}